// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDownloadURL } from "firebase/storage";
import { serverTimestamp } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyBAw67HLL3VtYOLWX01Uv9x-htjtI4n_Eg",
  authDomain: "tfyo-12e98.firebaseapp.com",
  projectId: "tfyo-12e98",
  storageBucket: "tfyo-12e98.appspot.com",
  messagingSenderId: "620180421774",
  appId: "1:620180421774:web:b60e04f9ae1e9eabc85ddf",
  measurementId: "G-LP5FWX9FRC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const timestamp = serverTimestamp();
const db = getFirestore(app);

export { auth }
export { timestamp }
export { db }

export const uploadToStorage = async (uploadTask) => {
  return new Promise((resolve, reject) => {
    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on('state_changed',
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        switch (snapshot.state) {
          case 'paused':
            break;
          case 'running':
            break;
        }
      },
      (error) => {
        // Handle upload error
        switch (error.code) {
          case 'storage/unauthorized':
            // User doesn't have permission to access the object
            break;
          case 'storage/canceled':
            // User canceled the upload
            break;

          // ...

          case 'storage/unknown':
            // Unknown error occurred, inspect error.serverResponse
            break;
        }

        reject(error);
      },
      async () => {
        // Upload completed successfully, now we can get the download URL
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          resolve(downloadURL);
        });
      }
    );
  });
}